import { lazy } from 'react';

export default [
  {
    path: '/',
    component: lazy(() => import('./Main')),
  },
  {
    path: '/sign-in',
    component: lazy(() => import('./SignIn')),
  },
  {
    path: '/sign-up',
    component: lazy(() => import('./SignUp')),
  },
  {
    path: '/forgot-password',
    component: lazy(() => import('./ForgotPassword')),
  },
  {
    path: '/games/:id?',
    component: lazy(() => import('./Games')),
  },
  {
    path: '/game/:id',
    component: lazy(() => import('components/sections/GameIframe')),
  },
  {
    path: '/promotions',
    component: lazy(() => import('./Promotions')),
  },
  {
    path: '/promotions/:id',
    component: lazy(() => import('./Promotions/PromotionDetails')),
  },
  {
    path: '/game-history',
    component: lazy(() => import('./GameHistory')),
  },
  {
    path: '/bonuses-history',
    component: lazy(() => import('./BonusesHistory')),
  },
  {
    path: '/bonuses',
    component: lazy(() => import('./Bonuses')),
  },
  {
    path: '/tournaments',
    component: lazy(() => import('./Tournaments')),
  },
  {
    path: '/sport/*',
    component: lazy(() => import('./Sport')),
  },
  {
    path: '/wallet-history',
    component: lazy(() => import('./WalletHistory')),
  },
  {
    path: '/payment/deposit/:providerId',
    component: lazy(() => import('./PaymentDepositRedirect')),
  },
  {
    path: '/deposit',
    component: lazy(() => import('./Payments/Deposit')),
  },
  {
    path: '/withdraw',
    component: lazy(() => import('./Payments/Withdraw')),
  },
  {
    path: '/callback/bkash',
    component: lazy(() => import('./BashCallback/BashCallback')),
  },
  {
    path: '/verification',
    component: lazy(() => import('./Verification/PlayerVerification')),
  },
  {
    path: '/2fa',
    component: lazy(() => import('./UserSection/TwoFactorAuthentication')),
  },
  {
    path: '/player/profile',
    component: lazy(() => import('./UserSection/UserProfile')),
  },
  {
    path: '/player/reset-password',
    component: lazy(() => import('./UserSection/ChangePassword')),
  },
  {
    path: '/info/*',
    component: lazy(() => import('./StaticContent/StaticContentRouter')),
  },
  {
    path: '*',
    component: lazy(() => import('./Redirect')),
  },
];
